/**
 * Was für ein Gerät ist das — und zwar nur da, wo es wirklich darauf ankommt.
 *
 * **Das Gerät zu erfragen ist die Ausnahme und keine Gewohnheit.** Fast alles
 * in dieser Anwendung entscheidet sich an einer Fähigkeit („kann dieser
 * Browser Dateien teilen?"), nicht an einem Namen — eine Kennung lügt, veraltet
 * und trifft das nächste Gerät falsch. Es gibt aber Fälle, in denen zwei
 * Systeme *dieselbe* Fähigkeit haben und mit ihr **etwas anderes tun**. Dann
 * hilft keine Abfrage der Fähigkeit weiter, und die Stelle gehört benannt
 * statt versteckt.
 *
 * Genau diese Datei ist der Ort dafür. Wer hier etwas ergänzt, schreibt dazu,
 * welche zwei Verhalten er auseinanderhält.
 */

/**
 * Ein iPhone oder ein iPad — Apple-System mit Finger.
 *
 * **Nicht über den Namen allein.** Ein iPad meldet sich seit iPadOS 13 als
 * „Macintosh"; wer nur nach `iPad` sucht, hält es für einen Rechner. Und ein
 * echter Mac meldet **null** Berührpunkte — daran, und nur daran, lassen sich
 * die beiden auseinanderhalten. Beides zusammen trifft genau die Geräte, um
 * die es geht.
 *
 * **Größer als null und nicht größer als eins.** Ein iPhone meldet fünf, das
 * war die erste Fassung; ein Fenster mit nachgestellter Berührung meldet aber
 * eine, und damit fiel der Prüfstand durch das Raster. Die Zahl ist hier auch
 * gar nicht die Frage — gefragt ist „hat dieses Gerät einen Finger", und das
 * beantwortet jede Zahl über null. Ein Rechner mit Berührbildschirm trägt
 * kein `Mac` oder `iPhone` in seiner Kennung und fällt schon dort heraus.
 *
 * Gebraucht wird das an zwei Stellen, und beide Male aus demselben Grund:
 * dort tut Apple etwas anderes als der Rest.
 *
 * - **Sichern eines Fotos** (`lib/sichern.ts`): auf iOS legt das Teilen-Blatt
 *   das Bild in *Fotos*, ein Download landet dagegen in *Dateien*. Auf Android
 *   ist es umgekehrt.
 * - **Der Hinweis zum Installieren** (`SettingsPage`): Push gibt es dort nur
 *   für Web-Apps auf dem Home-Bildschirm.
 */
export function istAppleMitFinger(): boolean {
  return navigator.maxTouchPoints > 0 && /Mac|iPad|iPhone|iPod/.test(navigator.userAgent)
}
